import React, { useEffect, useState } from "react";
import { ValidateResponse, getCurrentPage, setCurrentPage } from "../../helpers/global";
import { fetchProductCleanings, getProductStatus } from "../../helpers/articles";
import { List } from "../../../components/List";
import { ListPagination } from "../../../components/List/Pagination";
import { Message } from "../../../components/Message";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AppArticlesProductCleanings({ productId, current, setFilterFields, filterValues, identifier }) {

    let pageSize = 10; // default values ergens globaal opslaan?

    //const { status } = useParams();
    const [cleanings, setCleanings] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadFilters, setLoadFilters] = useState(true);
    const [pageNr, setPageNr] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [error, setError] = useState();
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem("filters" + identifier)));
    const [filterString, setFilterString] = useState();

    if (JSON.stringify(filterValues) !== filterString) {
        setFilterString(JSON.stringify(filterValues));
        setIsLoaded(false);
        setFilters(filterValues);
        setCurrentPage(1, current, setPageNr);
    }

    if (pageNr !== getCurrentPage(current)) {
        setPageNr(getCurrentPage(current));
    }

    const handlePagination = (page) => {
        setCurrentPage(page, current, setPageNr);
    }

    let listColumns = [
        { key: "statusLabel", label: "Status", type: "text" },
        { key: "createDate", label: "Aanmaakdatum", type: "date" },
        { key: "cleanDate", label: "Datum reiniging", type: "date" },
    ];

    // Afgevoerd zie je niet... wel afgerond
    const optionsConclusion = [
        { value: "PROCESSING", label: "In behandeling" }, // new/processing/waiting
        { value: "RELEASED", label: "Afgerond" }, // new/processing/waiting
        { value: "REPAIR", label: "Naar reparatie" }, // new/processing/waiting
    ]

    // // The filters are set here and send to parent onloaded
    let filterFields = {
        'conclusion': { type: 'select', label: "Status", options: optionsConclusion },
    }

    useEffect(() => {

        const callData = {
            filters: {
                productId: productId,
                limitOffset: pageSize * pageNr - (pageSize - 1),
                limitRows: pageSize,
                ...filters
            }
        }

        fetchProductCleanings(callData).then((res) => {

            const response = ValidateResponse(res.data, 'cleanings');

            if (response.status === 'error') {
                setError(response.message, response.status);
            }
            else {
                if (response.totalCount !== undefined) {
                    setTotalCount(response.totalCount);
                    
                    if (loadFilters !== current) {
                        setFilterFields(filterFields);
                        setLoadFilters(current);
                    }
                }
                setCleanings(response.cleanings);
                setIsLoaded(true);
            }
        }).catch((error) => {
            const response = ValidateResponse(error);
            setError(response.message);
        });

    }, [productId, pageNr, pageSize, filters, setFilterFields]);

    let message = getProductStatus(productId) === 'REMOVED' ? "Huplmiddel is afgevoerd" : null;

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (cleanings === undefined || cleanings === null || Object.keys(cleanings).length === 0) {
        return (
            <>
                <Message type="warning" message={message} />
                <Message type="noData" />
            </>
        );
    }

    return (
        <>
            <Message type="warning" message={message} />

            <List
                columns={listColumns}
                data={cleanings}
                identifier={identifier}
            />

            <div className={'spacer'}></div>

            <ListPagination
                currentPage={pageNr}
                totalCount={totalCount}
                pageSize={pageSize}
                setCurrentPage={handlePagination}
            />
            <div style={{ height: '30px' }}></div>
        </>
    );
}